
import { UserCog, Building, Database, Calculator, FileSpreadsheet, Settings, Calendar, BarChart3, MapPin, TrendingUp, Users } from "lucide-react";

export interface NavigationModule {
  id: string;
  name: string;
  icon: React.ComponentType<{ className?: string }>;
  permission: string | null;
  subModules?: NavigationModule[];
}

export const navigationModules: NavigationModule[] = [
  { id: "users", name: "User Management", icon: UserCog, permission: "manage_users" },
  { id: "suppliers", name: "Supplier Management", icon: Building, permission: "manage_suppliers" },
      { 
        id: "prices", 
        name: "Price Database", 
        icon: Database, 
        permission: "view_all_tenders",
        subModules: [
          { id: "price-schedule", name: "Price Update", icon: Calendar, permission: "view_all_tenders" },
          { id: "historical-prices", name: "Historical Prices", icon: BarChart3, permission: "view_all_tenders" },
          { id: "regional-factors", name: "Regional Factors", icon: MapPin, permission: "view_all_tenders" },
          { id: "price-trends", name: "Price Trends", icon: TrendingUp, permission: "view_all_tenders" }
        ]
      },
  // New standalone module: Labour Database
  { id: "labour-database", name: "Labour Database", icon: Users, permission: null },
  { id: "pricing-standard", name: "Pricing Standard", icon: Calculator, permission: null, subModules: [
    { id: "rate-calculator", name: "Rate Calculator", icon: Calculator, permission: null }
  ] },
  { id: "cost-model", name: "Cost Model", icon: FileSpreadsheet, permission: null, subModules: [
    { id: "cost-model-components", name: "Cost Components", icon: FileSpreadsheet, permission: null },
    { id: "cost-model-subcomponents", name: "Subcomponents", icon: Settings, permission: null },
    { id: "cost-model-geozones", name: "Geo Zones", icon: MapPin, permission: null },
    { id: "cost-model-overview", name: "System Overview", icon: Database, permission: null }
  ] },
  { id: "bill-of-quantities", name: "Bill of Quantity", icon: Settings, permission: null }
];
